import { InteractionType } from '../../types/communication/communicationDataType'
import { CameraFileFullPageImage, CameraPreviewImgContainer } from '../styled/File.style';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { tqPageView } from '../../utils/utils';
import Drawer from '../drawer/Drawer';
import { PhotoTypeEnum } from '../../types/commonTypes';

interface CameraFileImgFullPageCmpProps {
    file: InteractionType;
    close: any
    previewCustomClass?: string;
    titleImageDetail?: string
}

const CameraFileImgFullPageCmp = ({ file, close, previewCustomClass, titleImageDetail }: CameraFileImgFullPageCmpProps) => {
    const [loaded, setLoaded] = useState(false)
    const isLoadedClass = loaded ? 'is-loaded' : ''
    let { token } = useParams();
    let previewURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/download-attachment/${file._id}`;

    useEffect(() => {
        // Analytics
        tqPageView('cai:foto evento:foto')
        // Analytics in case of foto danno
        if (file?.file_type === PhotoTypeEnum.DANNO_VEICOLO_DOCS ||
            file?.file_type === PhotoTypeEnum.DANNO_VEICOLO_CTP_DOCS) {
            tqPageView('cai:raccolta foto:foto aggiuntive')
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const imgLoadedHandler = () => {
        setLoaded(true)
    }

    return (
        <>
            <Drawer
                previewCustomClass={previewCustomClass}
                drawerMainContentCustomClass={'camera-photo-drawer-content'}
                onClose={close}
                titleImageDetail={titleImageDetail}
            >
                <CameraPreviewImgContainer className={isLoadedClass}>
                    <CameraFileFullPageImage
                        src={previewURL}
                        alt="Foto camera contesto full page"
                        onLoad={imgLoadedHandler} />
                </CameraPreviewImgContainer>
            </Drawer>
        </>
    )
}

export default CameraFileImgFullPageCmp
